import { SchemaWidgetInstance } from "../SchemaWidgetClass";

const stripTags = (str: string) => {
  if (!str) return null;
  return str.replace(/<\/?[^>]+(>|$)/g, "");
};

export const postalAddressJson = (data: SchemaWidgetInstance, page: any) => {
  const isPostalAddress = data.get("type") === "PostalAddress";

  const postAddressJsonLd = {
    "@context": "https://schema.org",
    "@type": "PostalAddress",
    name: isPostalAddress
      ? data.get("name")
      : stripTags(data.get("locationName")) ||
        stripTags(page?.get("locationName")) ||
        null,
    description: isPostalAddress
      ? data.get("description")
      : data.get("locationDescription") ||
        page?.get("locationDescription") ||
        null,
    streetAddress:
      data.get("streetAddress") || page?.get("locationStreet") || null,
    addressLocality:
      data.get("addressLocality") || page?.get("locationCity") || null,
    addressRegion:
      data.get("addressRegion") || page?.get("locationRegion") || null,
    postOfficeBoxNumber: data.get("postOfficeBoxNumber") || null,
    postalCode:
      data.get("postalCode") || page?.get("locationPostalCode") || null,
    addressCountry:
      data.get("addressCountry") || page?.get("locationCountry") || null,
    url: data.get("locationUrl") || page?.get("locationUrl") || null,
  };

  return postAddressJsonLd;
};
